import {
  Container,
  Grid,
  TextField,
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
} from '@mui/material'
import { ExpandMoreOutlined } from '@mui/icons-material'
import Drawer from 'components/drawer/detail'
import Loading from 'components/loading/loading'
import { useGetDetailHyundaiModelQuery } from 'store/hyundaiModel'
import type { DetailStateProps } from 'modules/types'
import ImageBox from 'components/ImageBox'
import DetailStyle from './style'

const Detail = ({ open, id, onClose }: DetailStateProps & { id: number }) => {
  const { data, isLoading, isFetching } = useGetDetailHyundaiModelQuery(id, { skip: !open })
  if (!open) return <Drawer open={open} onClose={onClose} />

  const name = (data && data.name) || '-'
  const discontinued = data && data.discontinued ? 'Yes' : 'No'
  const brochureUrl = (data && data.brochureUrl) || '-'
  const description = (data && data.description) || '-'

  const gridDataLabel = ['Hyundai Car Name', 'Discontinued', 'BrochureUrl', 'Description']
  const gridDataValue = [name, discontinued, brochureUrl, description]

  const status = (data && data.status) || '-'
  const createdBy = (data && data.createdBy) || '-'
  const createdAt = (data && data.createdAt) || '-'
  const modifiedBy = (data && data.modifiedBy) || '-'
  const modifiedAt = (data && data.modifiedAt) || '-'

  const gridBasicLabel = ['status', 'Created By', 'Created At', 'Modified By', 'Modified At']
  const gridBasicValue = [status, createdBy, createdAt, modifiedBy, modifiedAt]

  return (
    <Drawer open={open} title='Hyundai Car Model Detail' onClose={onClose}>
      <Container {...DetailStyle.Container}>
        {(isLoading || isFetching) && !data && <Loading />}
        {data && (
          <Grid container spacing={2}>
            {gridDataValue.map((item, index) => (
              <Grid key={index} item xs={12}>
                <TextField
                  variant='outlined'
                  label={gridDataLabel[index]}
                  value={item}
                  inputProps={{ readOnly: true }}
                  InputLabelProps={{
                    shrink: true
                  }}
                  fullWidth
                />
              </Grid>
            ))}
            <Grid item xs={12}>
              <ImageBox src={data.image ?? ''} alt={data.name} label='Image' />
            </Grid>
          </Grid>
        )}
        {data && (
          <Accordion elevation={0} disableGutters>
            <AccordionSummary expandIcon={<ExpandMoreOutlined />} aria-controls='basic-information'>
              <Typography>Basic Information</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container spacing={2}>
                {gridBasicValue.map((item, index) => (
                  <Grid key={index} item xs={12}>
                    <TextField
                      variant='outlined'
                      label={gridBasicLabel[index]}
                      value={item}
                      inputProps={{ readOnly: true }}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                  </Grid>
                ))}
              </Grid>
            </AccordionDetails>
          </Accordion>
        )}
      </Container>
    </Drawer>
  )
}

export default Detail
